module.exports = __webpack_public_path__ + "img/kulaW.b6bdd63b.png";